import DedicatedDeployments from './DedicatedDeployments';

export default DedicatedDeployments;
